// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('commonsComponents/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
require('./myProfileEcommerceKeyView.scss');

// @ constants
const infoIcon = require('assets/images/icon-info-blue.svg');

class MyProfileEcommerceKeyView extends React.Component {
    constructor(props) {
        super(props);
    }

    handleCheckKeyClick() {
        this.props.history.push('/myprofile/keys/ecommerce/check');
    }

    handleModifyKeyClick() {
        this.props.history.push('/myprofile/keys/ecommerce/modify');
    }

    buildCheckEcommerceKeyButton() {
        return(
            <div className="my-profile-ecommerce-key-info__check-button-container">
                <OKButton modifier="secondary" onClick={() => this.handleCheckKeyClick()}>
                    <FormattedText value="eCommerceKeyInfo-checkKey" />
                </OKButton>
            </div>
        )
    }

    buildModifyEcommerceKeyButton() {
        return(
            <OKButton modifier="primary" inverse onClick={() => this.handleModifyKeyClick()}>
                <FormattedText value="eCommerceKeyInfo-modifyKey" />
            </OKButton>
        )
    }

    buildInfoEcommerce() {
        const checkEcommerceKeyButton = this.buildCheckEcommerceKeyButton();
        const hiddenPassword = '·······'
        return (
            <div>
                <div className="my-profile-ecommerce-key-info__section-container col-xs-12">
                    <div className="my-profile-ecommerce-key-info__section-container__title">
                        <FormattedText value={`eCommerceKeyInfo-titleSectionEcommerce`} />
                    </div>
                </div>
                <div className="my-profile-ecommerce-key-info__info-text--check col-xs-12">
                    <FormattedText value={`eCommerceKeyInfo-infoTextEcommerce`} />
                    <div className="my-profile-ecommerce-key-info__password">
                        {hiddenPassword}
                    </div>
                    <div className="my-profile-ecommerce-key-info__change-button-container col-xs-12">
                        {checkEcommerceKeyButton}
                    </div>
                </div>
            </div>
        )
    }

    buildContent() {
        const boxBody = (
            <div>
                <div className="keys-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ul className="contact-info-box__list">
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="eCommerceKeyInfo-boxBody1"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="eCommerceKeyInfo-boxBody2"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="eCommerceKeyInfo-boxBody3"
                        />
                    </li>
                </ul>
            </div>
        )
        const eCommerceInfoContent = this.buildInfoEcommerce();
        return (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        <div className="col-md-12">
                            <ContentBox>
                                <div className="my-profile-ecommerce-key-info row">
                                    <div className="col-xs-12">
                                        <OKBoxTitle value={formatText('eCommerceKeyInfo-title')} />
                                    </div>
                                    {eCommerceInfoContent}
                                </div>
                            </ContentBox>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={formatText('eCommerceKeyInfo-boxTitle')}
                                boxBody={boxBody}
                                icon={infoIcon}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        const content = this.buildContent();
        const mappingBreadcrumb = [
            {
                text: formatText('profileKeysLanding-title'),
                url: '/myprofile/keys'
            },
            {
            text: formatText('eCommerceKeyLanding-title'),
            url: ''
            }
        ];

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="large" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                titleWrap={true}
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('eCommerceKeyLanding-title')}
                            />
                            <div className="my-profile-keys-tpps-view__header-action-link-btn">
                                {this.buildModifyEcommerceKeyButton()}
                            </div>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-positive">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileEcommerceKeyView.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports.constructor = MyProfileEcommerceKeyView;
module.exports.MyProfileEcommerceKeyView = withRouter(MyProfileEcommerceKeyView);
